import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        $scope.showPropertyIncident = $scope.claimVm.lobs.commercialAuto.fixedPropertyIncident.propertyDescription.value;
        $scope.savedPropertyDescription = $scope.claimVm.lobs.commercialAuto.fixedPropertyIncident.propertyDescription.value;
    };

    ctrl.removePropertyDamage = () => {
        $scope.showPropertyIncident = false;
        $scope.savedPropertyDescription = $scope.claimVm.lobs.commercialAuto.fixedPropertyIncident.propertyDescription.value;
        $scope.claimVm.lobs.commercialAuto.fixedPropertyIncident.propertyDescription.value = undefined;
    };

    ctrl.addPropertyDamage = () => {
        $scope.showPropertyIncident = true;
        $scope.claimVm.lobs.commercialAuto.fixedPropertyIncident.propertyDescription.value = $scope.savedPropertyDescription;
    };

    ctrl.next = (flowNextFn, form) => {
        if (form.invalid) {
            if ($scope.fnol.lossLocationType === 'map') {
                $scope.fnol.lossLocationType = 'city_only';
            }
        }
        return flowNextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;
